import { LegalPageLayout } from './LegalPage';

const PolitiqueCookies = () => {
  return (
    <LegalPageLayout title="Politique de cookies">
      <h2>1. Qu'est-ce qu'un cookie ?</h2>
      <p>
        Un cookie est un petit fichier texte déposé par un site internet sur votre appareil (ordinateur,
        tablette, smartphone) lorsque vous le visitez. Les cookies permettent au site de « se souvenir »
        de vos actions ou préférences pendant une période donnée.
      </p>

      <h2>2. Quels cookies utilisons-nous ?</h2>

      <h3>2.1 Cookies strictement nécessaires (sans consentement requis)</h3>
      <p>
        Ces cookies sont indispensables au bon fonctionnement du site. Ils ne peuvent pas être désactivés.
      </p>
      <table className="w-full border-collapse my-4">
        <thead>
          <tr className="bg-stone-100">
            <th className="text-left p-3 border">Nom</th>
            <th className="text-left p-3 border">Finalité</th>
            <th className="text-left p-3 border">Durée</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="p-3 border">admin_token</td>
            <td className="p-3 border">Maintenir la session d'administration (réservé à l'administrateur)</td>
            <td className="p-3 border">Jusqu'à déconnexion</td>
          </tr>
          <tr>
            <td className="p-3 border">cookie_consent</td>
            <td className="p-3 border">Mémoriser votre choix concernant les cookies</td>
            <td className="p-3 border">12 mois</td>
          </tr>
        </tbody>
      </table>

      <h3>2.2 Cookies tiers (soumis à consentement)</h3>
      <p>
        Lorsque vous procédez à un paiement en ligne, notre prestataire <strong>Stripe</strong> dépose ses propres cookies
        pour sécuriser la transaction et détecter la fraude. Ces cookies sont régis par la politique de
        confidentialité de Stripe :{' '}
        <a href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noopener noreferrer"
          className="text-[#C62E2E]">
          https://stripe.com/cookies-policy/legal
        </a>
      </p>
      <p>
        Notre site affiche également une carte <strong>Google Maps</strong> sur la page Contact. Google peut déposer
        des cookies. En savoir plus :{' '}
        <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer"
          className="text-[#C62E2E]">
          https://policies.google.com/technologies/cookies
        </a>
      </p>

      <h2>3. Cookies que nous N'utilisons PAS</h2>
      <p>Pour votre information, notre site <strong>ne contient actuellement AUCUN</strong> :</p>
      <ul>
        <li>Cookie publicitaire</li>
        <li>Cookie de mesure d'audience (Google Analytics, etc.)</li>
        <li>Cookie de suivi comportemental</li>
        <li>Pixel Facebook ou autre pixel de réseau social</li>
      </ul>

      <h2>4. Comment gérer les cookies ?</h2>
      <p>
        Vous pouvez à tout moment modifier vos préférences en vidant les cookies stockés par votre navigateur.
        Chaque navigateur a sa propre procédure :
      </p>
      <ul>
        <li>
          <strong>Chrome :</strong>{' '}
          <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer"
            className="text-[#C62E2E]">support.google.com/chrome</a>
        </li>
        <li>
          <strong>Firefox :</strong>{' '}
          <a href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies" target="_blank"
            rel="noopener noreferrer" className="text-[#C62E2E]">support.mozilla.org</a>
        </li>
        <li>
          <strong>Safari :</strong>{' '}
          <a href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac" target="_blank"
            rel="noopener noreferrer" className="text-[#C62E2E]">support.apple.com</a>
        </li>
        <li>
          <strong>Edge :</strong>{' '}
          <a
            href="https://support.microsoft.com/fr-fr/microsoft-edge/supprimer-les-cookies-dans-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
            target="_blank" rel="noopener noreferrer" className="text-[#C62E2E]">support.microsoft.com</a>
        </li>
      </ul>
      <p>
        <strong>Attention :</strong> la désactivation de certains cookies peut rendre le site partiellement
        inutilisable (impossible de valider une commande ou une réservation).
      </p>

      <h2>5. Pour en savoir plus</h2>
      <p>
        Consultez notre{' '}
        <a href="/politique-confidentialite" className="text-[#C62E2E]">Politique de confidentialité</a>{' '}
        pour plus d'informations sur le traitement de vos données personnelles.
      </p>
    </LegalPageLayout>
  );
};

export default PolitiqueCookies;
